import React, { useEffect, useState } from "react";
import DTOSkillsDetailsModal from "./DTOSkillsDetailsModal";
import SkillsDetailsPresenter from "./SkillsDetailsPresenter";
import { updatePersonalDetailsService } from "../../../../api/services/updatePersonalDetailsService";
import { useAppDispatch, useAppSelector } from "../../../../infra/hooks";
import _ from "lodash";
import { getAllEmployeeSkills } from "../../../../infra/aggregates/myProfile/skillsSlice";
import toast from "react-hot-toast";

interface ModalInterface {
  isModalOpen: boolean;
  closeModal: any;
  trans?: any;
}

const SkillsDetailsController = ({
  isModalOpen,
  closeModal,
  trans,
}: ModalInterface) => {
  const selector = useAppSelector((state) => state.personalInfoSlice);
  const empId = useAppSelector((state) => state?.authSlice?.emp_id);
  const dispatch = useAppDispatch();
  const [suggestedSkills, setAllSuggestedSkills] = useState<[]>([]);
  const [selectedSkills, setSelectedSkills] = useState<any>([]);

  const getData = (data: any) => {
    addSkills(data);
  };

  async function callBackGetAllSuggestedSkills(skills: any) {
    setAllSuggestedSkills(skills);
  }

  async function addSkills(data: any) {
    if (empId && data) {
      let payload: any = {};
      if (typeof data == "string") {
        const formatSkill: any = [];
        formatSkill.push(data);
        payload = {
          emp_id: empId,
          skills: formatSkill,
          locale: localStorage.getItem("emplang"),
        };
      } else {
        payload = {
          emp_id: empId,
          skills: _.map(data, "name"),
          locale: localStorage.getItem("emplang"),
        };
      }

      await updatePersonalDetailsService
        .addEmployeeSkill(payload)
        .then((response: any) => {
          if (response.status == "success") {
            dispatch(getAllEmployeeSkills(response.data));
            closeModal();
            toast.success(trans("Added Successfully"));
          }
        })
        .catch((err) => toast.error(err?.response?.data?.data));
    } else {
      toast.error(trans("Invalid data"));
    }
  }
  return (
    <div>
      <DTOSkillsDetailsModal
        setAllSuggestedSkills={callBackGetAllSuggestedSkills}
        selectedSkills={selectedSkills}
      />
      <SkillsDetailsPresenter
        callBackSelectedSkills={getData}
        isModalOpen={isModalOpen}
        closeModal={closeModal}
        allSuggestedSkills={suggestedSkills}
        selectedEmployeeDetail={selector}
        trans={trans}
      />
    </div>
  );
};

export default SkillsDetailsController;
